var exports = {
  "kL": "container__0EBcvh",
  "p_": "list__rbNF2B",
  "AS": "item__3F9vTb",
  "q0": "textOnly___7C0tV",
  "nf": "link__1VaySd",
  "qV": "skeleton__wQFuU6",
  "Qq": "text__0MPhkv",
  "Kk": "icon__WXkZES",
  "U0": "condensed__bcv84U",
  "il": "condensedList__hzL6Zh",
  "mr": "alwaysVisible__ib2C5l",
  "SO": "fullList__brdRjI",
};

module.exports = exports;
